export default {
  bestOffer: {
    en: '<span class="brandColor">Best Offer:</span> only <span class="brandColor">{count}</span> products left',
  },
  almostThere: {
    en: '<span class="brandColor">Almost there!</span> Just <span class="brandColor">1</span> more',
  },
  yay: {
    en: '<span class="brandColor">YAY!</span> You <span class="brandColor">unlocked</span> the deluxe bag!',
  },
  addToUnlock: {
    en: 'Add <span class="brandColor">{count}</span> more products to unlock a free deluxe beauty bag',
  },
  unlocked: {
    en: 'Free deluxe beauty bag is now added to your order',
  },
}
